import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/img/logos/fiews-white.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "position-relative d-print-none" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "shape shape-bottom shape-fluid-x text-dark" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      viewBox: "0 0 2880 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z",
        fill: "currentColor"
      })
    ])
  ])
], -1)
const _hoisted_2 = { class: "py-8 py-md-11 bg-dark d-print-none" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-md-4 col-lg-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "...",
  class: "footer-brand img-fluid mb-2",
  style: {"max-width":"180px"}
}, null, -1)
const _hoisted_7 = { class: "text-gray-700 mb-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "col-6 col-md-4 col-lg-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-uppercase text-gray-700" }, "Products", -1)
const _hoisted_11 = { class: "list-unstyled text-muted mb-6 mb-md-8 mb-lg-0" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "col-6 col-md-4 col-lg-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-uppercase text-gray-700" }, "Services", -1)
const _hoisted_19 = { class: "list-unstyled text-muted mb-5" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-uppercase text-gray-700" }, "Company", -1)
const _hoisted_22 = { class: "list-unstyled text-muted mb-0" }
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "col-6 col-md-4 col-lg-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-uppercase text-gray-700" }, "Legal", -1)
const _hoisted_27 = { class: "list-unstyled text-muted mb-0" }
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = { class: "mb-3" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"col-6 col-md-4 col-lg-2\"><h6 class=\"fw-bold text-uppercase text-gray-700\">Social</h6><ul class=\"list-unstyled text-muted mb-0\"><li class=\"mb-3\"><a href=\"https://twitter.com/Fiewsio\" target=\"_blank\" class=\"text-reset\">Twitter</a></li><li class=\"mb-3\"><a href=\"https://medium.com/fiews\" target=\"_blank\" class=\"text-reset\">Medium</a></li><li class=\"mb-3\"><a href=\"https://t.me/fiewsio\" target=\"_blank\" class=\"text-reset\">Telegram</a></li></ul></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar = _resolveComponent("navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_navbar),
    _createVNode(_component_router_view),
    _hoisted_1,
    _createElementVNode("footer", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, [
              _createElementVNode("small", null, [
                _createTextVNode("Copyright © 2018-" + _toDisplayString(new Date().getFullYear()) + " Fiews, LLC.", 1),
                _hoisted_8,
                _createTextVNode(" All rights reserved.")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: "/solutions",
                  class: "text-reset"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Solutions")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: "/blockchains/ethereum",
                  class: "text-reset"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ethereum")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_14, [
                _createVNode(_component_router_link, {
                  to: "/blockchains/binance-smart-chain",
                  class: "text-reset"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Binance Smart Chain")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createVNode(_component_router_link, {
                  to: "/blockchains/polygon",
                  class: "text-reset"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Polygon")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_16, [
                _createVNode(_component_router_link, {
                  to: "/blockchains/avalanche-c-chain",
                  class: "text-reset"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Avalanche C-Chain")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("ul", _hoisted_19, [
              _createElementVNode("li", _hoisted_20, [
                _createVNode(_component_router_link, {
                  to: "/dedicated-nodes",
                  class: "text-reset"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Dedicated nodes")
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_21,
            _createElementVNode("ul", _hoisted_22, [
              _createElementVNode("li", _hoisted_23, [
                _createVNode(_component_router_link, {
                  to: "/about",
                  class: "text-reset"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("About")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_24, [
                _createVNode(_component_router_link, {
                  to: "/contact",
                  class: "text-reset"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Contact")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("ul", _hoisted_27, [
              _createElementVNode("li", _hoisted_28, [
                _createVNode(_component_router_link, {
                  to: "/terms",
                  class: "text-reset"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Terms of use")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_29, [
                _createVNode(_component_router_link, {
                  to: "/privacy-policy",
                  class: "text-reset"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Privacy Policy ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_30, [
                _createVNode(_component_router_link, {
                  to: "/refunds",
                  class: "text-reset"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Refund Policy ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _hoisted_31
        ])
      ])
    ])
  ], 64))
}